<template>
  <DialogWrapper
    class="recommendation-list-dialog"
    close-on-cancel
    hidden-header-line
    hide-footer
    :loading="loading"
    :show.sync="isShow"
  >
    <TableList
      class="load-task-list"
      hide-on-click
      :titleI18nKey="`${i18nPrefix}.label.aiRecommendedHistoryTitle`"
      :listData="tableListData"
      :tableColumns="tableColumns"
      :showCreateBtn="false"
      :actionBtn="actionBtn"
      :pagination="pagination"
    >
      <template #btn>
        <el-button class="refresh-btn" @click="handleRefreshHistory">{{ $t('common.btn.refresh') }}</el-button>
      </template>
      <template #createdTime="{ row }">
        <div class="date">{{ row.createdTime.date }}</div>
        <div class="time">{{ row.createdTime.time }}</div>
      </template>
    </TableList>
  </DialogWrapper>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { LOAD_TASK_STATUS } from '@/constant/talentRecommendation'

export default {
  components: {
    DialogWrapper,
    TableList
  },
  props: {
    recommendationList: {
      type: Array
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const vm = this
    return {
      i18nPrefix: 'admin.application.applicantList',
      loading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        get total () {
          return vm.loadTaskList.length
        }
      },
      actionBtn: {
        view: {
          show: (row) => LOAD_TASK_STATUS.isFinished(row.status),
          labelI18nKey: 'admin.application.applicantList.btn.talentRecommendation.view',
          onclick: this.onView
        },
        viewCondition: {
          labelI18nKey: 'admin.application.applicantList.btn.talentRecommendation.viewCondition',
          onclick: this.onViewCondition
        },
        retry: {
          show: (row) => LOAD_TASK_STATUS.isEmpty(row.status) || LOAD_TASK_STATUS.isFailed(row.status),
          labelI18nKey: 'admin.application.applicantList.btn.talentRecommendation.retry',
          onclick: this.onRetry
        }
      },
      loadTaskList: []
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    tableListData () {
      const end = this.pagination.page * this.pagination.pageSize
      const start = end - this.pagination.pageSize
      return this.loadTaskList.slice(start, end)
    },
    tableColumns () {
      const columns = [
        {
          dataKey: 'createdTime',
          label: this.$t(`${this.i18nPrefix}.label.talentRecommendation.createdTime`),
          width: 90,
          slotName: 'createdTime'
        },
        {
          dataKey: 'creatorName',
          label: this.$t(`${this.i18nPrefix}.label.talentRecommendation.creatorName`),
          showOverflowTooltip: true
        },
        {
          dataKey: 'serialNumber',
          label: this.$t(`${this.i18nPrefix}.label.talentRecommendation.serialNumberTitle`),
          width: 140,
          formatter: (val, row) => {
            let labelKey = 'serialNumberBest'
            if (val > 1) {
              labelKey = 'serialNumber'
            }
            return this.$t(`${this.i18nPrefix}.label.talentRecommendation.${labelKey}`, { index: row.recommendationSerialNumber, date: row.createdDate, loadTask: val - 1 })
          }
        },
        {
          dataKey: 'status',
          label: this.$t(`${this.i18nPrefix}.label.talentRecommendation.loadTaskStatus`),
          formatter: (val) => {
            if (LOAD_TASK_STATUS.isEmpty(val)) {
              val = 'empty'
            } else if (LOAD_TASK_STATUS.isFinished(val)) {
              val = 'success'
            } else if (LOAD_TASK_STATUS.isFailed(val)) {
              val = 'failed'
            } else {
              val = 'pending'
            }
            return this.$t(`${this.i18nPrefix}.recommendationLoadTaskStatus.${val}`)
          }
        }
      ]
      return columns
    }
  },
  created () {

  },
  methods: {
    showActionBtn (row) {
      return !LOAD_TASK_STATUS.isRunning(row.status)
    },
    onView (row) {
      this.$emit('view', row.recommendationId, row.id)
      this.isShow = false
    },
    onViewCondition (row) {
      this.$emit('viewCondition', row.recommendationId, row.id)
    },
    onRetry (row) {
      this.$emit('retry', row.recommendationId, row.id)
      this.isShow = false
    },
    handleRefreshHistory () {
      this.loading = true
      this.$emit('refresh', () => {
        this.loading = false
      })
    },
    refreshLoadTaskList () {
      const list = []
      const vm = this
      _.forEach(this.recommendationList, (recommendation) => {
        _.forEach(recommendation.load_task_list, (loadTask) => {
          const createdTime = moment(loadTask.created_time)
          list.push({
            id: loadTask.id,
            createdDate: createdTime.format('YYYY/MM/DD'),
            createdTime: {
              get date () {
                const [year, month, weekday, day] = createdTime.locale(vm.$i18n.locale).format('YYYY,MMM,dddd,Do').split(',')
                return vm.$t(`${vm.i18nPrefix}.label.aiTaskTime`, { year, month, weekday, day })
              },
              time: createdTime.format('H:mm')
            },
            recommendationId: recommendation.id,
            recommendationSerialNumber: recommendation.serial_number,
            status: loadTask.status,
            serialNumber: loadTask.serial_number,
            creatorName: recommendation.created_account.full_name
          })
        })
      })
      this.loadTaskList = list
    }
  },
  watch: {
    recommendationList: {
      handler () {
        this.refreshLoadTaskList()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.recommendation-list-dialog {
  ::v-deep {
    .el-dialog {
      width: 60%;
    }
  }
  .load-task-list {
    .refresh-btn {
      margin-left: auto;
      padding: 6px 20px;
      border-radius: 4px;
    }

    .date {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
